export const setLocation = (newLocation) => {
    window.location.href = `${window.location.origin}${newLocation}`;
};
